export const API_CONST = {
  API_LOGIN_ADMIN: "/api.d/admin/login",
  API_LOGIN_USER: "/api.d/user/login",
  LIST_USERS_ROLE: "/api.d/admin/role",
  GET_REGISTER_ADMIN_BASIC_INFORMATION: "/api.d/admin/user/basic-information",
  ADMIN_USER: "/api.d/admin/user",
  ADMIN_UPDATE_USER: "/api.d/admin/user/update",
  ADMIN_USER_DETAIL: "/api.d/admin/user/detail",
  VALIDATE_ADMIN_USER_REGISTER: "/api.d/admin/user/validate",
  API_LOGOUT_ADMIN: "/api.d/admin/logout",
  API_LOGOUT_USER: "/api.d/user/logout",
  API_LIST_ALL_USER: "/api.d/admin/user/list-all",
  API_LIST_ACTIVATION: "/api.d/admin/user/activation-requests",
  SEND_SMS_REGISTER_USER: "/api.d/user/sms/send-sms-register-user",
  SEND_SMS_LOGIN_USER: "/api.d/user/login/second-auth-sms",
  RESEND_SMS_LOGIN_USER: "/api.d/user/login/resend-sms",
  VERIFY_SMS_REGISTER_USER: "/api.d/user/sms/verify-sms-register-user",
  VERIFY_ACTIVATION_CODE: "/api.d/user/login/verify-activation-code",
  GET_BASIC_INFORMATION_USER_PAGE:
    "/api.d/user/user/basic-information-register-user",
  GET_ADDRESS_BY_POSTAL: "/api.d/user/address/get-address-by-postal",
  GET_BANK: "/api.d/user/bank/get-bank",
  POST_VALIDATE_FORM: "/api.d/user/user/validation",
  USER_API: "/api.d/user/user",
  USER_UPDATE_API: "/api.d/user/user/update",
  USER_DETAIL_API: "/api.d/user/user/detail",
  CHECK_MAIL_ADMIN_EXIST: "/api.d/admin/user/check-exist-email",
  CHECK_EXIST_EMAIL_API: "/api.d/user/user/check-exist-email",
  SEARCH_GUARANTEE_MST: "/api.d/admin/guarantee-register/search",
  GET_GUARANTEE_DETAIL: "/api.d/admin/guarantee-register/guarantee-detail",
  UPDATE_GUARANTEE_STATUS: "/api.d/admin/guarantee-register",
  USER_API_LIST_TRADE_ORDER: "/api.d/user/trade-order",
  ADMIN_API_LIST_TRADE_ORDER: "/api.d/admin/trade-order",
  SEND_WEBYUBIN_ACTIVATION_CODE: "/api.d/admin/web-yubin/send",
  GET_BASIC_INFORMATION_LOAN_REQUEST_PAGE: "/api.d/user/loan/basic-information",
  GET_DATA_LOAN_REQUEST_DETAIL: "/api.d/user/loan",
  ACCEPT_LOAN_REQUEST: "/api.d/user/loan/accept",
  APPROVE_LOAN_REQUEST: "/api.d/user/loan/approve",
  REJECT_LOAN_REQUEST: "/api.d/user/loan/reject",
  CONFIRM_LOAN_REQUEST: "/api.d/user/loan/confirm",
  CANCEL_LOAN_REQUEST: "/api.d/user/loan/cancel",
  GET_DATA_LOAN_REQUEST_CONFIRM: "/api.d/user/loan/get-data-confirm",
  API_BASIC_INFORMATION_LINK_ERP_MODAL: "/api.d/user/server/basic-information",
  API_GET_DATA_CORP_SERVER: "/api.d/user/server/get-data-corp",
  API_ERP_LINK: "/api.d/user/server/erp-link",
  API_VALIDATE_FORM_LOAN_REQUEST: "/api.d/user/loan/validation",
  API_SAVE_FORM_LOAN_REQUEST: "/api.d/user/loan",
  USER_SEND_MAIL_FORGOT_PASSWORD: "/api.d/user/reset-password/send",
  USER_GET_MAIL_TOKEN: "/api.d/user/reset-password/get-mail",
  USER_RESET_PASSWORD: "/api.d/user/reset-password/update-password",
  ADMIN_SEND_MAIL_FORGOT_PASSWORD: "/api.d/admin/reset-password/send",
  ADMIN_GET_MAIL_TOKEN: "/api.d/admin/reset-password/get-mail",
  ADMIN_RESET_PASSWORD: "/api.d/admin/reset-password/update-password",
  GET_DEBT_DETAIL: "/api.d/admin/debt",
  GET_DEBT_LIST: "/api.d/admin/debt",
  GET_PAYMENT_HISTORY: "/api.d/admin/payment/history-list",
  GET_HISTORY_PAYMENT_EXTENSION:
    "/api.d/admin/debt/list-history-payment-extension",
  EXPORT_CSV: "/api.d/admin/debt/export-csv",
  API_GET_LIST_DEBT: "/api.d/admin/debt/list",
  MANUAL_RECEIPT: "/api.d/admin/debt/manual-receipt",
  GUARANTEE_PAYMENT: "/api.d/admin/debt/guarantee-payment",
  UPDATE_HAS_TRANSFER_MONEY: "/api.d/admin/debt/update-status-transfer-money",
  ADMIN_CONTACT: "/api.d/admin/contact",
  ADMIN_CONTACT_UPDATE_LIST: "/api.d/admin/contact/update-list",
  ADMIN_GET_BASIC_CONTACT_INFO: "/api.d/admin/contact/basic-contact-info",
  USER_CONTACT: "/api.d/user/contact",
  USER_GET_BASIC_CONTACT_INFO: "/api.d/user/contact/basic-contact-info",
  USER_CONTACT_UPDATE_LIST: "/api.d/user/contact/update-list",
  AUTO_RECEIPT: "/api.d/admin/debt/import-auto-receipt",
  POST_REQUEST_GUARANTEE: "/api.d/admin/debt/request-guarantee",
  POST_UPDATE_EARLY_FUNDING: "/api.d/admin/debt/update-early-funding",
  UPDATE_PAYMENT_EXTENSION: "/api.d/admin/debt/payment-extension",
  EXPORT_FB: "/api.d/admin/debt/export-firm-banking",
  UPDATE_EARLY_FUNDING_STATUS: "/api.d/admin/debt/update-status-early-funding",
  SEND_SMS_VERIFY_NEW_PHONE_NUMBER: "/api.d/user/sms/send-sms-verify-new-phone-number",
  VERIFY_NEW_PHONE_NUMBER: "/api.d/user/sms/verify-new-phone-number",
  USER_UPDATE_STATUS_LOAN: "/api.d/user/trade-order",
  ADMIN_UPDATE_STATUS_LOAN: "/api.d/admin/trade-order",
  GET_CORP_TEMP_INFO_API: "/api.d/user/user/get-corp-temp-info",
  USER_CREATE_SUPPORT:"/api.d/user/support/create",
  ADMIN_CREATE_SUPPORT:"/api.d/admin/support/create",
  USER_GET_SUPPORT_DETAIL:"/api.d/user/support/detail-message",
  ADMIN_GET_SUPPORT_DETAIL:"/api.d/admin/support/detail-message",
  USER_UPDATE_SUPPORT:"/api.d/user/support",
  ADMIN_UPDATE_SUPPORT:"/api.d/admin/support",
  UPDATE_USER_STATUS:"/api.d/admin/user/update-users-status",
  UPDATE_STATUS:"/api.d/admin/user/update-status",
  USER_GET_INFO_USER:"/api.d/user/contact/get-info-user",
  USER_GET_TERM:"/api.d/user/terms/terms-info",
  USER_GET_TERMS_SERVICE_BY_FINANCING_TYPE:"/api.d/user/terms/get-terms-service-by-finance-type",
  USER_REQUEST_TO_CANCEL: "/api.d/user/user/request-to-cancel",
};

export const URL = {
  REGISTER: "/admin/register",
  CONFIRM_REGISTER: "/admin/register-confirm",
  USER_REGISTER: "/user/register",
  USER_REGISTER_CONFIRM: "/user/register-confirm",
  USER_REGISTER_THANK: "/user/register-thanks",
  USER_LOGIN: "/user/login",
  LOAN_REQUEST: "/user/loan-request",
  ADMIN_LOGIN: "/admin/login",
  LIST_USER: "/admin/user-manage",
  DEBT_LIST: "/admin/debt-list",
  ERROR_403: "/error/403",
  USER_MYPAGE: "/user/mypage",
  USER_LOAN_REQUEST_DETAIL: "/user/loan-request-detail",
  LOAN_REQUEST_DETAIL_CONFIRM: "/user/loan-request-detail-confirm",
  USER_REGISTER_TRADE_ORDER: "/user/register-trade-order",
  USER_DETAIL_TRADE_ORDER: "/user/detail-trade-order",
  ADMIN_LOAN_REQUEST_DETAIL: "/admin/loan-request-detail",
  ADMIN_DETAIL: "/admin/user-detail",
  USER_DETAIL: "/user/user-detail",
  ADMIN_UPDATE_CONFIRM: "/admin/update-confirm",
  USER_UPDATE_CONFIRM: "/user/update-confirm",
  USER_MANAGE: "/admin/user-manage",
  ADMIN_USER_REGISTER: "/admin/register",
  ADMIN_ONLINE_LOAN_MANAGE: "/admin/online-loan-manage",
  ADMIN_CONTACT: "/admin/contact",
  USER_CONTACT: "/user/contact",
  NOTIFICATION: "/user/notification",
  ACTIVATION_REQUESTS: "/admin/activation-requests",
  USER_RESET_PASSWORD: "/user/reset-password",
  USER_RESET_PASSWORD_THANKS: "/user/reset-password-thanks",
  USER_SETTING_PASSWORD: "/user/setting-password",
  USER_SETTING_PASSWORD_THANKS: "/user/setting-password-thanks",
  ADMIN_RESET_PASSWORD: "/admin/reset-password",
  ADMIN_RESET_PASSWORD_THANKS: "/admin/reset-password-thanks",
  ADMIN_SETTING_PASSWORD: "/admin/setting-password",
  ADMIN_SETTING_PASSWORD_THANKS: "/admin/setting-password-thanks",
  GUARANTEE_LIST: "/admin/guarantee-register-list",
  GUARANTEE_DETAIL: "/admin/guarantee-register-detail",
  DEBT_DETAIL: "/admin/debt-detail",
  ERROR_404: "/error_404",
  LOAN_REQUEST_CONFIRM: "/user/loan-request-confirm",
};

export const URL_ERROR = {
  403: "{modules}/login",
  401: "{modules}/login",
};

export const ALLOW_URL_BY_ROLE = {
  "1": [
    URL.USER_MANAGE,
    URL.ADMIN_USER_REGISTER,
    URL.ADMIN_ONLINE_LOAN_MANAGE,
    URL.ADMIN_CONTACT,
    URL.GUARANTEE_LIST,
    URL.DEBT_LIST,
  ],
  "2": [URL.ACTIVATION_REQUESTS, URL.ADMIN_CONTACT, URL.DEBT_LIST],
  "3": [URL.GUARANTEE_LIST, URL.DEBT_LIST],
  "4": [URL.ADMIN_ONLINE_LOAN_MANAGE, URL.ADMIN_CONTACT, URL.DEBT_LIST],
  "5": [URL.USER_MYPAGE, URL.LOAN_REQUEST, URL.USER_CONTACT],
};

// Types
export type LIST_USERS_ROLE_TYPE = {
  id: number;
  role_name: string;
};

// Types
export type LIST_BANK = {
  bank_code: number;
  bank_name: string;
};

export type REGISTER_ADMIN_BASIC_INFORMATION = {
  list_role: LIST_USERS_ROLE_TYPE[];
  list_bank: LIST_BANK[];
};

export type ADMIN_USER_TYPE = {
  mail_address?: string;
  password?: string;
  user_name?: string;
  password_confirmation?: string;
  role_id?: number;
  id?: number;
  bank_code?: string;
  status?: number;
};

export type SEND_SMS_REGISTER_USER_TYPE = {
  phone_number: string;
};
// Basic information user page
export type BASIC_INFORMATION_USER_PAGE = {
  annual_sales_scale: {
    [key: string]: string;
  };
  capital_classification: {
    [key: string]: string;
  };
  employee_num: {
    [key: string]: string;
  };
  industry_major: {
    [key: string]: string;
  };
  industry_middle: {
    [key: string]: any;
  };
  service_terms: string;
};

// Address information
export type ADDRESS_INFORMATION = {
  prefecture: string;
  city: string;
  address: string;
};

export type USER_REGISTER = {
  id: number;
  classAgreement: number;
  corpName: string;
  corpNum: string;
  employeeNum: number;
  foundationDate: string;
  presidentName: string;
  presidentNameKana: string;
  presidentBirthday: string;
  industryMajor: string;
  industryMiddle: string;
  capitalClassification: number;
  annualSalesScale: number;
  postNo1: number;
  postNo2: number;
  address1: string;
  address2: string;
  phoneNumber: string;
  representativePhoneNumber: string;
  userName: string;
  mailAddress: string;
  password: string;
  isAgree: boolean;
  employeeNumLabel: string;
  industryMajorLabel: string;
  industryMiddleLabel: string;
  capitalClassificationLabel: string;
  annualSalesScaleLabel: string;
  bankCd?: string;
  smsSkip?: boolean;
  erpDataId: number;
};

export type MAIL_USER = {
  is_exist: boolean;
};

export interface ListFinance {
  bank_code: string;
  bank_name: string;
}

export type ALLOW_BANK_CD = {
  [key: string]: string[];
}

// Basic information loan request page
export type BASIC_INFORMATION_LOAN_REQUEST_PAGE = {
  list_finance_type: {
    [key: string]: string;
  };
  list_use_of_funds: {
    [key: string]: string;
  };
  annual_sales_scale: {
    [key: string]: string;
  };
  employee_num: {
    [key: string]: string;
  };
  industry_major: {
    [key: string]: string;
  };
  industry_middle: {
    [key: string]: any;
  };
  housing_classification: {
    [key: string]: string;
  };
  loan_period_default: number;
  preferred_loan_date_default: number;
  list_prefecture: string[];
  loan_filter: any;
  loan_attributes: any;
  holidays: any;
  list_finance: ListFinance[];
  allow_bank_cd: ALLOW_BANK_CD;
  list_capital_classification: {
    [key: string]: string;
  };
  user_status: number;
  bank_cd: string|null;
};

// Basic information link erp modal
export type BASIC_INFORMATION_LINK_ERP_MODAL = {
  server: string;
  corp_id: string;
  user_id: string;
  list_service_name: [];
  list_server: [];
};

// Bank information
export type BANK_INFORMATION = {
  bank_code: string;
  branch_code: string;
  bank_name_hankana: string;
  branch_name_hankana: string;
};